import {
  FETCH_TOTEM_LOGS_REQUEST,
  FETCH_TOTEM_LOGS_SUCCESS,
  FETCH_TOTEM_LOGS_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  logs: [],
  error: null,
  isFetching: false,
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_TOTEM_LOGS_REQUEST:
      return {
        ...state,
        isFetching: true,
      }

    case FETCH_TOTEM_LOGS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        logs: action.payload,
      }

    case FETCH_TOTEM_LOGS_ERROR:
      return {
        ...state,
        isFetching: false,
        logs: [],
        error: action.payload,
      }

    default:
      return state
  }
}

export default record
